import { render, staticRenderFns } from "./SettingsChat.vue?vue&type=template&id=77d70258"
import script from "./SettingsChat.vue?vue&type=script&lang=js"
export * from "./SettingsChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports